import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const FooterStyled = styled.footer`
  width: 100%;
  padding: 57px 20px 0px;
  display: flex;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 57px 20px 0px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 34px 0px 80px;
  `};
`

export const Logo = styled.img`
  display: block;
  width: 135px;
  margin-right: calc(100% - 135px);
  margin-bottom: 37px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 113px;
    margin-right: calc(100% - 113px);
    margin-bottom: 32px;
  `};
`

export const Info = styled.div`
  flex-shrink: 0;
  padding-right: 40px;
`

export const Socials = styled.div`
  display: flex;
  margin-bottom: 35px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 32px;
  `};
`

export const Social = styled.a`
  margin-right: 16px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #000;
  border-radius: 10px;
  background: #e85a44;
  transition: 0.2s;

  svg {
    min-width: 20px;
  }

  svg path {
    fill: white;
  }

  &:hover {
    background: #f3ba2f;
    transition: 0.2s;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 8px;
    width: 40px;
    height: 40px;
  `};
`

export const EmailLabel = styled.div`
  font-size: 18px;
  color: #564a27;
  margin-bottom: 7px;
`

export const Email = styled.div`
  font-size: 24px;
  margin-bottom: 33px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 22px;
  `};
`

export const Nav = styled.nav`
  display: flex;
  justify-content: space-around;
  margin-left: auto;
  width: 60%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
    margin: 10px auto 0px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    justify-content: flex-start;
  `};
`

export const NavList = styled.ul<{ isOpen: boolean }>`
  flex-basis: 200px;
  margin: 0px;
  padding: 0px;
  margin-right: 20px;

  ${({ theme, isOpen }) => theme.mediaWidth.upToSmall`
    flex-basis: auto;
    flex-shrink: 0;
    width: 100%;
    margin-bottom: 8px;
    border-radius: 10px;
    background: #FFF;
    height: ${isOpen ? 'auto' : '55px'};
    overflow: hidden;
  `};
`

export const NavTitle = styled.div<{ isOpen: boolean }>`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;

  svg {
    display: none;
  }

  ${({ theme, isOpen }) => theme.mediaWidth.upToSmall`
    padding: 16px 16px 20px;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      display: block;
      transition: 0.2s;
      transform: rotateX(${isOpen ? '3.142rad' : '0rad'});
    }
  `};
`

export const NavItem = styled.li`
  margin: 0px;
  padding: 0px;
  margin-bottom: 18px;
  list-style-type: none;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 0px;

    &:last-child {
      margin-bottom: 8px;
    }
  `};
`

export const NavLink = styled(Link)`
  font-size: 16px;
  color: #564a27;
  text-decoration: none;
  transition: 0.2s;

  &:hover {
    color: #f3ba2f;
    transition: 0.2s;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: block;
    padding: 10px 20px;
  `};
`

export const Copyright = styled.div`
  width: 100%;
  margin-top: 12px;
  padding: 20px 0px;
  text-align: center;
  font-size: 16px;
  color: #929292;
`
